import { ADFState } from "./user-state"

export enum UserActionTypeEnum {
    INVALID_OTL = "INVALID_OTL",
    USER_LOGOUT = "USER_LOGOUT",
    USER_AUTHENTICATED = "USER_AUTHENTICATED",
    SET_USER = "SET_USER",
    SAVE_EMAIL = "SAVE_EMAIL",
    LEGAL_DISCLAIMER_ACCEPTED = "LEGAL_DISCLAIMER_ACCEPTED",
    SAVE_USER_INFO = "SAVE_USER_INFO",
    SET_PERSONAL_DETAILS= "SET_PERSONAL_DETAILS",
    SET_PORTFOLIO_TEAM_CODE= "SET_PORTFOLIO_TEAM_CODE",
    SET_PORTFOLIO_ID = "SET_PORTFOLIO_ID",
    SET_PORTFOLIO_COMPANIES = "SET_PORTFOLIO_COMPANIES",
};

export type UserAction = {
    type: UserActionTypeEnum.INVALID_OTL,
    invalidOTL: boolean 
} | {
    type: UserActionTypeEnum.USER_LOGOUT
    userLogOut: boolean,
    userInactivelyLoggedOut: boolean
} | {
    type: UserActionTypeEnum.USER_AUTHENTICATED
    userAuthenticated: boolean
} | {
    type: UserActionTypeEnum.SET_USER
    user: any
} | {
    type : UserActionTypeEnum.SAVE_EMAIL
    email : string
} | {
    type : UserActionTypeEnum.LEGAL_DISCLAIMER_ACCEPTED
    accepted : boolean
} | {
    type: UserActionTypeEnum.SAVE_USER_INFO
    userInfo: any
} | {
    type: UserActionTypeEnum.SET_PERSONAL_DETAILS
    details: any
} | {
    type: UserActionTypeEnum.SET_PORTFOLIO_TEAM_CODE
    userTeamCodes: any
} | {
    type: UserActionTypeEnum.SET_PORTFOLIO_ID
    portfolioId: any
} | {
    type: UserActionTypeEnum.SET_PORTFOLIO_COMPANIES
    userCompanies: any
}


export type DispatchType = (args: UserAction) => UserAction

export function invalidOTLAction(invalidOTL: boolean) {
    return {
        type: UserActionTypeEnum.INVALID_OTL,
        invalidOTL
    }
}

export function userLogOutAction(userLogOut: boolean, userInactivelyLoggedOut: boolean) {
    return {
        type: UserActionTypeEnum.USER_LOGOUT,
        userLogOut,
        userInactivelyLoggedOut
    }
}

export function setUserAuthenticated(userAuthenticated: boolean) {
    return {
        type: UserActionTypeEnum.USER_AUTHENTICATED,
        userAuthenticated
    }
}

export function setUserAction(user: any) {
    return {
        type: UserActionTypeEnum.SET_USER,
        user
    }
}

export function setUserPortfolio(userTeamCodes: any) {
    return {
        type: UserActionTypeEnum.SET_PORTFOLIO_TEAM_CODE,
        userTeamCodes
    }
}

export function setUserPortfolioId(portfolioId: any) {
    return {
        type: UserActionTypeEnum.SET_PORTFOLIO_ID,
        portfolioId
    }
}

export function setUserPortfolioCompanies(userCompanies: any) {
    return {
        type: UserActionTypeEnum.SET_PORTFOLIO_COMPANIES,
        userCompanies
    }
}

export function saveUserEmailAction(email : string) {
    return {
        type: UserActionTypeEnum.SAVE_EMAIL,
        email
    }
}

export function saveLegalDisclaimerAccepted(accepted : boolean) {
    return {
        type: UserActionTypeEnum.LEGAL_DISCLAIMER_ACCEPTED,
        accepted,
    }
}

export function saveUserInfoAction(userInfo: any) {
    return  {
        type: UserActionTypeEnum.SAVE_USER_INFO,
        userInfo
    }
}

export function setPersonalDetails(details: any) {
    return {
        type: UserActionTypeEnum.SET_PERSONAL_DETAILS,
        details
    }
}